import { rootApi } from '../api/rootApi';
import { getApi } from '../api/getApi';
import { postApi } from '../api/postApi';
import { putApi } from '../api/putApi';
import { deleteApi } from '../api/deleteApi';

export const servicesService = {
    getAllServices: async () => {
        return await getApi(rootApi.services);
    },
    getServiceById: async (id) => {
        return await getApi(`${rootApi.services}/${id}`);
    },
    addService: async (data) => {
        return await postApi(rootApi.services, data);
    },
    updateService: async (id, data) => {
        return await putApi(`${rootApi.services}/${id}`, data);
    },
    deleteService: async (id) => {
        return await deleteApi(`${rootApi.services}/${id}`);
    }
};
